import { apiSlice } from "./apiSlice";

export const subjectApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getSubjects: builder.query({
			query: () => "/Subject",
			providesTags: ["Subjects"],
		}),

		getSubjectById: builder.query({
			query: (id) => `/Subject/${id}`,
			providesTags: (result, error, id) => [{ type: "Subjects", id }],
		}),
	}),
});

export const { useGetSubjectsQuery, useGetSubjectByIdQuery } = subjectApiSlice;
